import React from 'react';

import Image from '../../library/image/image';
import EfficiencyChart from './components/efficiency-chart/efficiency-chart';

import './efficiency-data-info.scss';

interface EfficiencyDataInfoProps {
  className?: string;
  isEV?: boolean;
  value?: number;
}

function EfficiencyDataInfo(props: EfficiencyDataInfoProps) {
  const { className, isEV, value } = props;

  return (
    <div className={className} styleName="container">
      <Image
        alt="Efficiency Logo"
        height="22"
        src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/treadwell-blue-tire-leaf.svg"
        width="22"
      />
      <strong>{isEV ? 'EV Range Influence' : 'Fuel Efficiency'}</strong>
      <div styleName="chart-wrapper">
        <EfficiencyChart value={value} />
        <div styleName="labels">
          <div>
            <span>high rolling resistance</span>
            <span>low rolling resistance</span>
          </div>
          <div>
            <span>{isEV ? 'shorter range' : 'lower MPG'}</span>
            <span>{isEV ? 'longer range' : 'higher MPG'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EfficiencyDataInfo;
